import { render, staticRenderFns } from "./ReviewsPrsPlate.vue?vue&type=template&id=810d15d8&scoped=true&"
import script from "./ReviewsPrsPlate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsPrsPlate.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewsPrsPlate.vue?vue&type=style&index=0&id=810d15d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810d15d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810d15d8')) {
      api.createRecord('810d15d8', component.options)
    } else {
      api.reload('810d15d8', component.options)
    }
    module.hot.accept("./ReviewsPrsPlate.vue?vue&type=template&id=810d15d8&scoped=true&", function () {
      api.rerender('810d15d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsPrsPlate.vue"
export default component.exports